function toFixed(v, n = 8) {
  if (!v) return 0
  const num = +v
  const x = (+parseFloat(num).toPrecision(16)).toFixed(12).split('.')
  if (n <= 0) return x[0]
  let f = x[1] || ''
  if (f.length > n)
    return `${x[0]}.${f.substring(0, n)}`.replace(/(\.0+|0+)$/, '')
  while (f.length < n) f += '0'
  return `${x[0]}.${f}`.replace(/(\.0+|0+)$/, '')
}

export { toFixed }
